__turbopack_context__.v({
  "bannerImage": "StickyMediaRail-module__1n6RMa__bannerImage",
  "bannerVideo": "StickyMediaRail-module__1n6RMa__bannerVideo",
  "cta": "StickyMediaRail-module__1n6RMa__cta",
  "ctaRow": "StickyMediaRail-module__1n6RMa__ctaRow",
  "media": "StickyMediaRail-module__1n6RMa__media",
  "mediaDark": "StickyMediaRail-module__1n6RMa__mediaDark",
  "mediaLight": "StickyMediaRail-module__1n6RMa__mediaLight",
  "metaRow": "StickyMediaRail-module__1n6RMa__metaRow",
  "name": "StickyMediaRail-module__1n6RMa__name",
  "nameDark": "StickyMediaRail-module__1n6RMa__nameDark",
  "nameLight": "StickyMediaRail-module__1n6RMa__nameLight",
  "note": "StickyMediaRail-module__1n6RMa__note",
  "noteDark": "StickyMediaRail-module__1n6RMa__noteDark",
  "noteLight": "StickyMediaRail-module__1n6RMa__noteLight",
  "primaryCta": "StickyMediaRail-module__1n6RMa__primaryCta",
  "rail": "StickyMediaRail-module__1n6RMa__rail",
  "reducedMotionImage": "StickyMediaRail-module__1n6RMa__reducedMotionImage",
});
